import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SDKLoadingComponent } from './sdk-loading.component';

@NgModule({
  declarations: [
    SDKLoadingComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SDKLoadingComponent
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class SDKLoadingModule { }
